import React from "react";
import CountDownComponent from "./countDown";
import images from "../../assets/images";
import "./style.css";

const CountDown = () => {
  const backgroundImage = `url(${images.countdown.countdown})`;

  return (
    <section id="countdown" style={{ backgroundImage }}>
      <div className="countdown-overlay" />
      <div className="countdown-content" data-aos="fade-up">
        <p className="countdown-label">Nuestra boda comienza en</p>
        <div className="countdown-rule"></div>
        <CountDownComponent />
        <p className="countdown-date">19 · Septiembre · 2026</p>
      </div>
    </section>
  );
};

export default CountDown;
